import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import App from './App';
import { AiLoaderProvider } from './components/ui/loader';
import { ConfigProvider, ThemeProvider, ToastProvider } from './hoc';
export const AiInterview = ({ config, isPreview = false, theme, children, session, }) => {
    // Create the client ONCE (useState initializer) — the previous
    // `new QueryClient()` in the render body rebuilt the client (and wiped the
    // whole cache) on every re-render.
    //
    // Global default: do NOT refetch on window focus / network reconnect. With
    // the bare default (refetchOnWindowFocus: true) every query refetched each
    // time the browser tab regained focus, flipping `isFetching` and making
    // pages that gate their UI on it flash back to their loading skeletons — the
    // "page reloads when I switch browser tabs and come back" seen across the
    // app. Individual queries can still opt back in when they need live refresh.
    const [queryClient] = useState(() => new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
            },
        },
    }));
    return (_jsx(QueryClientProvider, { client: queryClient, children: _jsx(ThemeProvider, { theme: theme, children: _jsx(ConfigProvider, { config: config, children: _jsx(ToastProvider, { children: _jsx(AiLoaderProvider, { children: _jsx(App, { isPreview: isPreview, children: children }) }) }) }) }) }));
};
